<script>
	import Compartir from "../components/Compartir.svelte";
	import { Link, navigate } from "svelte-routing";
	import { onMount } from "svelte";
	export let empleados, userCard, indexPersona;

	$:{
		console.log(empleados)
	} 
	const buscaId = (indexPersona) =>{
		let demo = empleados.filter(empleado => indexPersona == empleado.id)
		return demo;
		
	}
	let empleado = buscaId(indexPersona);
	let vcard = empleado[0];
	onMount(()=>{
		if(empleado.length == 0){
			navigate('/', {replace: true});
		}
	})
	const dirigirMaps = (id) =>{
		let demo = empleados.filter(empleado => id.indexPersona == empleado.id)
		userCard = demo[0]
		indexPersona = userCard.id;
		navigate(`/maps/${userCard.id}`, {replace: true});
	}
</script>
{#if empleado.length > 0}
<div class="body">
	<div class="bg-primary cabecera">
		{#if vcard.photo}
		<div class="avatar">
			<img src="../images/vcard/{vcard.photo}" alt="">
		</div>
		{/if}
		<div class="text-center">
			<h2>
				{vcard.nombres}
			</h2>
			<p>{vcard.cargo}</p>
		</div>
	</div>
	<div class="datos bg-primary">
		{#if vcard.movil!=''}
		<div>
			<a href="tel:{vcard.movil}" target="_blank">
				<img src="../images/phone_1.svg" alt="">
				CALL
			</a>
		</div>
		{/if}
		{#if vcard.email!=''}
		<div>
			<a href="mailto:{vcard.email}?subject=From%20my%20vCard&body=" target="_blank">
				<img src="../images/mail.svg" alt="">
				EMAIL
			</a>
		</div>
		{/if}
		{#if vcard.direccion}
		<div>
			<a href="https://www.google.com/" on:click|preventDefault={()=>dirigirMaps({indexPersona})}>
				<img src="../images/marker.svg" alt="">
				ADDRESS
			</a>
		</div>
		{/if}
	</div>
	<div style="padding: 0 10px;">
		<div class="group-datos">
			{#if vcard.descripcion}
			<div class="l-datos">
				<div class="logo">
				</div>
				<div class="data text-300">
					{vcard.descripcion}
				</div>
			</div>
			{/if}
			{#if vcard.movil}
			<div class="l-datos">
				<div class="logo">
					<img src="../images/phone.svg" alt="">
				</div>
				<div class="data line">
					<div class="text">
						<a href="tel:{vcard.movil}" target="_blank">
							{vcard.movil}
						</a>
					</div>
					<span>Mobile</span>
				</div>
			</div>
			{/if}
			{#if vcard.fijo}
			<div class="l-datos">
				<div class="logo">
				</div>
				<div class="data">
					<div class="text">
						{vcard.fijo}
					</div>
					<span>Teléfono</span>
				</div>
			</div>
			{/if}
			{#if vcard.fax}
			<div class="l-datos">
				<div class="logo">
				</div>
				<div class="data">
					<div class="text">
						{vcard.fax}
					</div>
					<span>Fax</span>
				</div>
			</div>
			{/if}
			{#if vcard.email}
			<div class="l-datos">
				<div class="logo">
					<img src="../images/email.svg" alt="">
				</div>
				<div class="data line">
					<div class="text">
						<a href="mailto:{vcard.email}?subject=From%20my%20vCard&body=" target="_blank">
							{vcard.email}
						</a>
					</div>
					<span>Email</span>
				</div>
			</div>
			{/if}
			{#if vcard.direccion}
			<div class="l-datos">
				<div class="logo">
					<img src="../images/marker_1.svg" alt="">
				</div>
				<div class="data line">
					<div class="text mb-2">
						{vcard.direccion}
					</div>
					<a class="blue" on:click={()=>dirigirMaps({indexPersona})}>
						<small>MAP VIEW</small>
					</a>
				</div>
			</div>
			{/if}
			{#if vcard.web_page.length > 0}
			{#each vcard.web_page as value, index}
			<div class="l-datos">
				<div class="logo">
					{#if index==0}
					<img src="../images/web-site.svg" alt="">
					{/if}
				</div>
				<div class="data line">
					<div>
						<a class="text" href="{value.link}" target="_blank">
							{value.link}
						</a>
					</div>
					<span>{value.name}</span>
				</div>
			</div>
			{/each}
			{/if}
			<div class="l-datos">
				<div class="logo">
				</div>
				<div class="data line">
					<!-- <div class="text">
						Social Network
					</div> -->
					<ul class="social">
						{#each vcard.redes_sociales as red, index}
						{#if red.link}
						<li>
							<a class="blue" href="{red.link}">
								<img src="../images/logos/{red.red}.png" alt=""/>
							</a>
						</li>
						{/if}
						{/each}
					</ul>
				</div>
			</div>
			<Compartir {vcard} {indexPersona} ></Compartir>
		</div>
	</div>
	<div class="footer">
		<Link to="/">
		<img src="../images/poviard.svg" alt=""/>
	</Link>
</div>
</div>
{/if}
<style lang="scss">
.social{
	max-width: 280px;
	width: 100%;
	padding-left: 0px;
	display: flex;
	flex-wrap: wrap;
}
.social	li{
	list-style: none;
	margin: 10px 10px 0 0;
}
.group-datos{
	position: relative;
	padding-bottom: 7.5em;
}
.footer{
	background: var(--blue-dark);
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.2em;
	// margin-top: 3.5em;
}
</style>